import React from "react";
import "./VideoYoutube.css";

const VideoYoutube = ({ youtubeId, mobile }) => {

  const styleWeb = {
    position: "relative",
    paddingBottom: "56.25%" /* 16:9 */,
    paddingTop: 25,
    height: 0,
    marginBottom:10
  }

  const styleMobile = {
    position: "relative",
    paddingBottom: "56.25%" /* 16:9 */,
    paddingTop: 25,
    height: 0,
    width:270,
    marginBottom:10,
    marginLeft: -13
  }



  const style = !mobile ? styleWeb : styleMobile

  return (
    <div
      className="video"
      style={style}
    >
      <iframe
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        src={`https://www.youtube.com/embed/${youtubeId}`}
        frameBorder="0"
      />
    </div>
  );
};

export default VideoYoutube;
